<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <el-input size="mini" v-model="search.DepartmentName" placeholder="部门名称搜索" class="etms-router-search-element fl"></el-input>
      <el-tooltip class="item" effect="dark" content="添加部门信息" placement="top">
        <el-button size="mini" @click="insetrDeparment" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询部门信息" placement="top">
        <el-button size="mini" @click="searchClick" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-table :border="true" :data="deps" height="90%" class="etms-router-list">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="70px"></el-table-column>
      <el-table-column label="部门" prop="departmentName"></el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <!-- <el-table-column label="员工数" prop="EmployeesNumber"></el-table-column> -->
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改部门信息" placement="top">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除部门" placement="top">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount">
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogvisible" :modal-append-to-body="false" width="500px" center>
      <el-form :model="form" :rules="rules" :ref="form.formname" label-width="120px" class="etms-dialog-form">
        <el-form-item label="部门名称 ：" prop="DepartmentName">
          <el-input size="mini" v-model="form.DepartmentName" placeholder="请输入部门名称" class="el-width-300"></el-input>
        </el-form-item>
        <el-form-item label="备注 ：" prop="Remarks">
          <el-input size="mini" v-model="form.Remarks" placeholder="部门备注信息(可空)" class="el-width-300"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    var departmentNameValidate = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsDepartmentName, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          DepartmentName: value,
          DepartmentId: self.form.DepartmentId
        }).then(res => {
          if (res.data.code == 200) { callback() }
          else { callback(res.data.Msg) }
        }).catch(error => { callback(error) })
      }
    }
    return {
      userinfo: this.$cookies.get('userinfo'),
      dialogTitle: '',
      dialogvisible: false,
      search: {
        DepartmentName: '',
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
      },
      form: {
        formname: 'depform',
        OptimisticLock: '',
        DepartmentId: '',
        DepartmentName: '',
        Remarks: ''
      },
      deps: [],
      rules: {
        DepartmentName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度请控制在100个字符以内', trigger: 'blur' },
          { validator: departmentNameValidate, trigger: 'blur' }
        ],
        Remarks: [
          { max: 500, message: '长度请控制在500个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.searchClick()
  },
  methods: {
    searchClick () {
      var self = this
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          DepartmentName: this.search.DepartmentName
        }
        this.$ajax.post(this.constant.openPaths.searchDepartmentPager, data).then(res => {
          if (res.data.code === 200) {
            var result = res.data.result
            self.deps = result.tList
            self.search.recordcount = result.recordCount
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    clearForm () {
      var form = this.form
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = 0
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    insetrDeparment () {
      this.dialogTitle = "新建部门"
      this.dialogvisible = true
      this.clearForm()
    },
    handleEdit (index, row) {
      this.dialogvisible = true
      this.dialogTitle = '编辑部门信息'
      this.form.OptimisticLock = row.optimisticLock
      this.form.DepartmentId = row.id
      this.form.DepartmentName = row.departmentName
      this.form.Remarks = row.remarks
    },
    handleDelete (index, row) {
      var self = this
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          DepartmentId: row.id,
          OptimisticLock: row.optimisticLock
        }
        this.$confirm('此操作将永久删除该部门,删除后不可恢复,是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax.post(this.constant.openPaths.deleteDepartment, data).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              self.deps.splice(index, 1)
            } else {
              self.$message.error(res.data.code)
            }
          }).catch(error => {
            self.$message.error(error)
          })
        })
      }
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.searchClick()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.searchClick()
    },
    dialogSave () {
      var self = this
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        DepartmentId: this.form.DepartmentId,
        OptimisticLock: this.form.OptimisticLock,
        DepartmentName: this.form.DepartmentName,
        Remarks: this.form.Remarks
      }

      var url = ''
      if (data.DepartmentId === '' && data.OptimisticLock === '') {
        url = this.constant.openPaths.insertDepartment
      }
      else {
        url = this.constant.openPaths.updateDepartment
      }
      this.$refs[this.form.formname].validate((valid) => {
        if (valid) {
          self.$ajax.post(url, data).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              self.clearForm()
              self.searchClick()
              self.dialogvisible = false
            } else { self.$message.error(res.data.msg) }
          }).catch(error => {
            self.$message.error(error)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/dep_manage.vue